import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  ContainerProps,
  Heading,
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { DefaultContainer } from '@/shared/ui';
import { IFAQ } from '../type/faqType';

interface IFAQProps extends ContainerProps {
  questions: IFAQ[];
}

const FAQ: FC<IFAQProps> = ({ questions, ...props }) => {
  const { t } = useTranslation();

  return (
    <DefaultContainer
      containerProps={{
        _odd: {
          bg: 'bg.light',
        },
      }}
      gap={{ base: 'sm', md: 'lg' }}
      {...props}
    >
      <Heading
        size={{ base: 'xl', md: '2xl' }}
        textAlign='center'
      >
        {t('common.faq.heading')}
      </Heading>
      <Accordion allowMultiple>
        {questions?.map?.(({ question, answer }) => (
          <AccordionItem
            key={question}
            borderBottom='1px'
            borderColor='border.light'
            borderTop={0}
          >
            <AccordionButton
              fontSize='xl'
              fontWeight='semibold'
              justifyContent='space-between'
              px='0'
              py='md'
              textAlign='left'
            >
              {question}
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel whiteSpace='pre-line'>{answer}</AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </DefaultContainer>
  );
};

export default FAQ;
